import { createContext, useState, useContext, useMemo } from "react";
import { Channels, ChangeChannel } from "../services/ChannelService";
import { AudienceContext } from "./AudienceContext";
import {
  getAccessTokenLocalStorage,
  ValidAccessTokenLocalStorage,
  handleUserLogOutErro,
  getChannelOrderLocalStorage,
} from "./utils";
import { UserPreferenceContext } from "./UserPreferenceContext";
import {
  CatchChannel,
  PushDisabledChannels,
  PushEnableChannels,
  hexToRGB,
  sortChannelByDesc,
} from "./ChannelsContextUtils";
import { ChannelDataOrder, IChannelDataResponse } from "./types";
import { NetworkAlertContext } from "../context/NetworkAlertContext";
import { useTranslation } from "react-i18next";
import { UiContext } from "./UiContext";

export const ChannelsContext = createContext({} as any);
let response;
let responseTemp;
const ChannelsProvider = ({ children }) => {
  const { setChannelsLength } = useContext(UiContext);


  const [channels, setChannels] = useState<IChannelDataResponse>();
  const [channelsMenu, setChannelsMenu] = useState<IChannelDataResponse>();
  const [channelsMenuTemp, setChannelsMenuTemp] =
    useState<IChannelDataResponse>();
  const { doAudience, setAudienceMedia, setAudienceMediaFirstTable, setAudience, setAudienceFirstTable, setLastAudience } = useContext(AudienceContext);
  const { userAuthenticated, setUserAuthenticated, setUserMenssageApi } =
    useContext(UserPreferenceContext);
  const { setInfoSpan, setShowInfo } = useContext(NetworkAlertContext);
  const { t: translateText } = useTranslation();

  async function doChannels() {
    setInfoSpan(translateText("network.loadingData"));
    setShowInfo(true);
    let token = getAccessTokenLocalStorage();
    let orderTypeChannel = getChannelOrderLocalStorage();
    if (ValidAccessTokenLocalStorage()) {
      await Channels(token)
        .then((res) => {
          response = res.data;
          responseTemp = [...response];
          const chanelsDataResponse: IChannelDataResponse = CatchChannel(
            response,
            orderTypeChannel
          );
          setChannelsLength(chanelsDataResponse.enabled.length)
          setChannels(chanelsDataResponse);
          const respString = JSON.stringify(chanelsDataResponse);
          setChannelsMenu(JSON.parse(respString) as IChannelDataResponse);
          setChannelsMenuTemp(JSON.parse(respString) as IChannelDataResponse);
        })
        .catch((err) => {
          handleUserLogOutErro(
            err,
            userAuthenticated,
            setUserAuthenticated,
            setUserMenssageApi
          );
        });
    }
  }
  async function doChangeChannel() {
    setInfoSpan(translateText("network.loadingData"));
    setShowInfo(true);
    let token = getAccessTokenLocalStorage();
    if (ValidAccessTokenLocalStorage()) {
      response = [...responseTemp];
      await ChangeChannel(token, response)
        .then((res) => {
          doChannels()
            .then((res) => { })
            .catch((err) => { });
          setAudienceMedia([]);
          setAudienceMediaFirstTable([]);
          setAudience([]);
          setAudienceFirstTable([]);
          setLastAudience([]);
          doAudience();
        })
        .catch((err) => {
          handleUserLogOutErro(
            err,
            userAuthenticated,
            setUserAuthenticated,
            setUserMenssageApi
          );
        });
    }
  }
  async function doCancelChangeChannel() {
    responseTemp = [...response];
    let chanelsMenu: IChannelDataResponse = {
      error: null,
      enabled: channels?.enabled ?? [],
      disabled: channels?.disabled ?? [],
      selected: channels?.selected ?? null,
    };
    setChannelsMenu(chanelsMenu);
    setChannelsMenuTemp(chanelsMenu);
  }
  async function doChangeOrderChannel() {
    setInfoSpan(translateText("network.loadingData"));
    setShowInfo(true);
    let orderTypeChannel = getChannelOrderLocalStorage();
    if (orderTypeChannel === ChannelDataOrder.ByLabel) {
      const channelEnabled = responseTemp.filter(
        (item) => item.Selected === true
      );
      let sortedEnabled = sortChannelByDesc(channelEnabled);
      sortedEnabled.forEach((channelSorted, index) => {
        response.forEach((responseChannel) => {
          if (responseChannel.Id === channelSorted.Id) {
            responseChannel.Seq = index;
          }
        });
      });
    }
    let token = getAccessTokenLocalStorage();
    if (ValidAccessTokenLocalStorage()) {
      response = [...responseTemp];
      await ChangeChannel(token, response)
        .then((res) => {
          doAudience();
          doChannels()
            .then((res) => { })
            .catch((err) => { });
        })
        .catch((err) => {
          handleUserLogOutErro(
            err,
            userAuthenticated,
            setUserAuthenticated,
            setUserMenssageApi
          );
        });
    }
  }
  async function doChangeColorChannel() {
    setInfoSpan(translateText("network.loadingData"));
    setShowInfo(true);
    let token = getAccessTokenLocalStorage();
    if (ValidAccessTokenLocalStorage()) {
      response = [...responseTemp];
      await ChangeChannel(token, response)
        .then((res) => {
          doChannels()
            .then((res) => { })
            .catch((err) => { });
        })
        .catch((err) => {
          handleUserLogOutErro(
            err,
            userAuthenticated,
            setUserAuthenticated,
            setUserMenssageApi
          );
        });
    }
  }

  function changeEnableChannel(id) {
    let result = PushEnableChannels(id, channelsMenuTemp, responseTemp);
    setChannelsMenuTemp(result);
  }

  function changeDisabledChannel(id) {
    let result = PushDisabledChannels(id, channelsMenuTemp, responseTemp);
    setChannelsMenuTemp(result);
  }

  function OrderSequency(orderSequency) {
    responseTemp.forEach((channel) => {
      orderSequency.enabled.forEach((channelsOrder) => {
        if (channel.Id === channelsOrder.id) {
          channel.Seq = channelsOrder.seq;
        }
      });
    });
  }

  function changeColor(color, id) {
    let channelsMenuClone: IChannelDataResponse = JSON.parse(
      JSON.stringify(channelsMenuTemp)
    );
    let result: IChannelDataResponse = {
      error: null,
      enabled: [...(channelsMenuClone?.enabled ?? [])],
      disabled: [...(channelsMenuClone?.disabled ?? [])],
      selected: [...(channelsMenuClone?.selected ?? "")],
    };
    let rgbColor = hexToRGB(color);
    let colorChangeChannel =
      "rgb(" + rgbColor.red + "," + rgbColor.green + "," + rgbColor.blue + ")";

    result?.enabled?.forEach((element) => {
      if (element.id === id) element.color = colorChangeChannel;
    });
    responseTemp.forEach((channel) => {
      if (channel.Id === id) {
        channel.Blue = rgbColor.blue;
        channel.Green = rgbColor.green;
        channel.Red = rgbColor.red;
      }
    });
    setChannelsMenu(result);
    setChannelsMenuTemp(result);
  }
  const objMemoProvider = useMemo(
    () => ({
      channels,
      channelsMenu,
      channelsMenuTemp,
      setChannels,
      setChannelsMenu,
      setChannelsMenuTemp,
      doChannels,
      doChangeChannel,
      doCancelChangeChannel,
      doChangeOrderChannel,
      changeEnableChannel,
      changeDisabledChannel,
      OrderSequency,
      changeColor,
      doChangeColorChannel
    }),
    [channels, channelsMenu, channelsMenuTemp]
  );

  return (
    <ChannelsContext.Provider value={objMemoProvider}>
      {children}
    </ChannelsContext.Provider>
  );
};

export default ChannelsProvider;
